import { Pipe, PipeTransform } from '@angular/core';
import { Iade } from '../const/globals.const';

@Pipe({
  name: 'toIADE',
  standalone: false,
})
export class toIADEPipe implements PipeTransform {
  transform(strIade: string): any {
    return strIade && strIade.toLowerCase() === Iade.toLowerCase() ? Iade.toUpperCase() : strIade;
  }
}
